export enum EPaymentType {
  ONLINE_PAYMENT = 'OP',
  CASH_ON_DELIVERY = 'COD',
}

export enum EDeliveryChargeType {
  INSIDE_OF_DHAKA = 'IN',
  OUTSIDE_OF_DHAKA = 'OUT',
}
